module.exports = __webpack_public_path__ + "static/commonwealth-b912f283d3758118100f44f7ede6b3a5.jpg";